import { ChevronLeft } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminPageLayout from "../../components/AdminPageLayout";
import ProviderSubscriptionsManager from "../../components/admin/ProviderSubscriptionsManager";

const ProviderSubscriptionsPage: React.FC = () => {
  const { providerId } = useParams<{ providerId: string }>();
  const navigate = useNavigate();
  const parsedProviderId = providerId ? Number(providerId) : null;

  return (
    <AdminPageLayout
      title="Provider Subscribers"
      description="Manage provider roster and subscription access"
      actions={
        <button
          type="button"
          onClick={() => navigate("/admin/subscriptions")}
          className="flex items-center rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition-colors hover:border-gray-300 dark:border-rp-separator dark:bg-rp-surface dark:text-gray-300 dark:hover:border-gray-600"
        >
          <ChevronLeft className="mr-2 h-4 w-4" />
          Back to Subscriptions
        </button>
      }
    >
      <ProviderSubscriptionsManager providerId={parsedProviderId} />
    </AdminPageLayout>
  );
};

export default ProviderSubscriptionsPage;
